export enum BookingTypeEnum {
  PAST = 'past',
  UPCOMING = 'upcoming',
  CANCELED = 'canceled',
  WAITING = 'waiting',
}
